export default __webpack_public_path__ + "static/media/kitchen3-afterI-1024w.313d602e.webp";